<template>
  <v-dialog width="500px" v-model="deleteErrorDialog">
    <template v-slot:activator="{ on }">
      <v-btn icon class="white--text" color="green" v-on="on" :disabled="disabled" :outlined="disabled">
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">close</v-icon>
          </template>
          <h3>Clear error</h3>
        </v-tooltip>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h3>Clear errors on this delivery</h3>
      </v-card-title>
      <v-divider color="#42a5f5"></v-divider>
      <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="deleteErrorDialog=false;">Cancel</v-btn>
          <v-btn text color="indigo" @click="deleteError">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  // @vuese
  // Dialog used to clear an error on a particular delivery
  // @group Search
  export default {
    name: "DeleteErrorDialog",
    props: {
      // Disabled if there is no error flagged for this delivery.
      disabled: Boolean,
      // Tracking number of the delivery
      tracking: String,
    },
    data() {
      return {
        deleteErrorDialog: false,
      }
    },
    methods: {
      // @vuese
      // Deletes all the errors for this delivery and post those changes on the API.
      deleteError() {
        axios.delete(process.env.API_URL + '/errors/' + this.tracking)
          .then((response) => {
            this.deleteErrorDialog = false;
            this.$emit('error-deleted', 'Error has been cleared');
          })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/DeleteErrorDialog.vue